<span class="position-relative ">
    <em class="fas fa-exclamation-triangle eod-text-danger padding-LR-5" placement="right" container="body"
    ngbTooltip="{{violationTooltip}}" tooltipClass="my-custom-class-additional-fields">
 </em>

 <span class="color-red">{{ data }}</span>


</span>
